import type { ScreenBackground } from '@/store/editor/types/screen';

/**
 * Решение владельца №3 (2026-10-08, повтор эталона Slimkit): «светлая
 * картинка фона». У эталона на экранах с фото на светлом фоне (04, 48, 56/57)
 * нет ни вуали, ни белого текста — тёмный текст темы лежит прямо на фото.
 * Наш ScreenBackgroundWrapper до этого ВСЕГДА затемнял картинку (явной или
 * адаптивной вуалью, WEB-1078) и прикалывал светлый текст (WEB-872).
 *
 * `imageTone: 'light'` выключает обе вещи разом — это одно решение автора
 * («картинка светлая»), а не две независимые галочки: вуаль без светлого
 * текста дала бы тёмное на тёмном, светлый текст без вуали — белое на белом.
 * Отсутствие поля и 'auto' — прежнее поведение.
 */
export function isLightImageBackground(
  background: Pick<ScreenBackground, 'imageTone'> | undefined,
): boolean {
  return background?.imageTone === 'light';
}
